import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
  accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { FormikProps } from "formik";
import {
  FormControl,
  FormHelperText,
  Grid2,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { MobileTimePicker, TimePicker } from "@mui/x-date-pickers";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowBackIosIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
      transform: "rotate(90deg)",
    },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
  ...theme.applyStyles("dark", {
    backgroundColor: "rgba(255, 255, 255, .05)",
  }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function NeededPay({ formik }: { formik: FormikProps<any> }) {
  const [expanded, setExpanded] = React.useState<string | false>("");

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
      formik.setFieldValue("isPayment", newExpanded);

      // اگر accordion بسته شد، فیلدهای مربوطه را پاک کن
      if (!newExpanded) {
        formik.setFieldValue("alertDayLeftForPayment1", undefined);
        formik.setFieldValue("alertDayLeftForPayment2", undefined);
        formik.setFieldValue("alertTimeAtForPayment", "");
        formik.setFieldValue("sampleSMSPayment", "");
      }
    };

  const [menuItems, setMenuItems] = React.useState<JSX.Element[]>([]);

  React.useEffect(() => {
    const items: JSX.Element[] = []; // اینجا نوع را مشخص کرده‌ایم
    for (let i = 1; i <= 30; i++) {
      items.push(
        <MenuItem key={i} value={i}>
          {i} روز بعد از تغییر وضعیت
        </MenuItem>
      );
    }
    setMenuItems(items); // بروزرسانی state با استفاده از setMenuItems
  }, []);

  React.useEffect(() => {
    if (formik.values.isPayment === "true") {
      setExpanded("panel2");
    }
  }, [formik.values.isPayment]);

  const [alertTime, setAlertTime] = React.useState<Date>();
  React.useEffect(() => {
    if (formik.values.alertTimeAtForPayment) {
      const currentDate = new Date();
      const [hours, minutes, seconds] = formik.values.alertTimeAtForPayment
        ?.split(":")
        ?.map(Number);
      currentDate.setHours(hours);
      currentDate.setMinutes(minutes);
      currentDate.setSeconds(seconds);
      setAlertTime(currentDate);
    } else {
      setAlertTime(undefined);
    }
  }, [formik.values.alertTimeAtForPayment]);

  return (
    <div>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          {/* <Stack
            direction={"row"}
            justifyContent={"space-between"}
            width={"100%"}
          > */}
          <Typography>
            نیاز به پرداختی: {expanded === "panel2" ? "دارد" : "ندارد"}
          </Typography>{" "}
          {/* <Typography>
              {expanded === "panel2" ? "تاریخ ارسال پیامک بعدی:-" : ""}
            </Typography>
          </Stack> */}
        </AccordionSummary>
        <AccordionDetails>
          <Grid2 container spacing={1} marginBottom={1} columns={13}>
            <Grid2 size={2}>
              <FormControl
                fullWidth
                error={
                  formik.touched.alertDayLeftForPayment1 &&
                  Boolean(formik.errors.alertDayLeftForPayment1)
                }
              >
                <InputLabel id="demo-simple-select-helper-label">
                  پیامک اول
                </InputLabel>
                <Select
                  fullWidth
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  value={
                    menuItems.length > 0 &&
                    formik.values.alertDayLeftForPayment1
                  }
                  label="پیامک اول"
                  onChange={(event, newValue) =>
                    formik.setFieldValue(
                      "alertDayLeftForPayment1",
                      //@ts-ignore
                      newValue?.props?.value
                    )
                  }
                >
                  <MenuItem value="">
                    <em>هیچی</em>
                  </MenuItem>
                  <MenuItem value={0}>همان لحظه</MenuItem>
                  {menuItems}
                </Select>
                <FormHelperText>
                  {
                    (formik.touched.alertDayLeftForPayment1 &&
                      formik.errors.alertDayLeftForPayment1) as boolean
                  }
                </FormHelperText>
              </FormControl>
            </Grid2>
            <Grid2 size={2}>
              <FormControl
                fullWidth
                error={
                  formik.touched.alertDayLeftForPayment2 &&
                  Boolean(formik.errors.alertDayLeftForPayment2)
                }
              >
                <InputLabel id="demo-simple-select-helper-label">
                  پیامک دوم
                </InputLabel>
                <Select
                  fullWidth
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  value={
                    menuItems.length > 0 &&
                    formik.values.alertDayLeftForPayment2
                  }
                  label="پیامک دوم"
                  onChange={(event, newValue) =>
                    formik.setFieldValue(
                      "alertDayLeftForPayment2",
                      //@ts-ignore
                      newValue?.props?.value
                    )
                  }
                >
                  <MenuItem value="">
                    <em>هیچی</em>
                  </MenuItem>
                  {menuItems}
                </Select>
                <FormHelperText>
                  {
                    (formik.touched.alertDayLeftForPayment2 &&
                      formik.errors.alertDayLeftForPayment2) as boolean
                  }
                </FormHelperText>
              </FormControl>
            </Grid2>
            <Grid2 size={2}>
              <FormControl
                fullWidth
                error={
                  formik.touched.alertDayLeftForPayment3 &&
                  Boolean(formik.errors.alertDayLeftForPayment3)
                }
              >
                <InputLabel id="demo-simple-select-helper-label">
                  پیامک سوم
                </InputLabel>
                <Select
                  fullWidth
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  value={
                    menuItems.length > 0 &&
                    formik.values.alertDayLeftForPayment3
                  }
                  label="پیامک سوم"
                  onChange={(event, newValue) =>
                    formik.setFieldValue(
                      "alertDayLeftForPayment3",
                      //@ts-ignore
                      newValue?.props?.value
                    )
                  }
                >
                  <MenuItem value="">
                    <em>هیچی</em>
                  </MenuItem>
                  {menuItems}
                </Select>
                <FormHelperText>
                  {
                    (formik.touched.alertDayLeftForPayment3 &&
                      formik.errors.alertDayLeftForPayment3) as boolean
                  }
                </FormHelperText>
              </FormControl>
            </Grid2>

            <Grid2 size={2}>
              <TimePicker
                label="در ساعت"
                onChange={(time: any) => {
                  const hours = time.getHours(); // دریافت ساعت
                  const minutes = time.getMinutes(); // دریافت دقیقه
                  const seconds = time.getSeconds(); // دریافت ثانیه (در صورت نیاز)
                  const timeString = `${hours}:${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
                  formik.setFieldValue("alertTimeAtForPayment", timeString);
                }}
                value={alertTime}
              />
            </Grid2>
            <Grid2 size={5}>
              <FormHelperText sx={{ mb: 1 }}>
                برای جای گذاری اسم مشتری در متن پیامک از "customer_name" استفاده
                کنید
              </FormHelperText>
              <TextField
                {...formik.getFieldProps("sampleSMSPayment")} // استفاده از ویژگی‌های فرمیک
                label="متن پیامک"
                multiline
                rows={4}
                error={
                  formik.touched.sampleSMSPayment &&
                  Boolean(formik.errors.sampleSMSPayment)
                }
                helperText={
                  (formik.touched.sampleSMSPayment &&
                    formik.errors.sampleSMSPayment) as boolean
                }
                variant="outlined"
                fullWidth
                inputProps={{
                  style: {
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  },
                }}
              />
            </Grid2>
          </Grid2>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
